import { AllocatedLab, AntibioticsTestStatus, PassOrFail, PlantsEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('rm_antibiotics_info')
export class RmAntiBioticsTest {
    @PrimaryGeneratedColumn('increment', { name: 'infoId' })
    infoId: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'grn_id'
    })
    grnId: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'grn_item_id'
    })
    grnItemId: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'indent_id',
    })
    indentId: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'indent_item_id',
    })
    indentItemId: number;

    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'plant_id'
    })
    plantId: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'product_id'
    })
    productId: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "product_code"
    })
    productCode: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "lot_number"
    })
    lotNumber: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "sampler_name"
    })
    samplerName: string;


    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'deheading_center'
    }) 
    deHeadingCenter: number;

    // @Column("varchar", {
    //     nullable: false,
    //     length: 50,
    //     name: "sample_details"
    // })
    // sampleDetails: string;


    @Column("int", {
        nullable: true,
        name: "count"
    })
    count: number;

    @Column("int", {
        nullable: true,
        name: "no_of_boxes"
    })
    noOfBoxes: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'c_a_p_l'
    })
    CAPL: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'c_a_p'
    })
    CAP: PassOrFail;

    @Column({
        type: 'int',
        nullable: true,
        name: 'a_o_z_l'
    })
    AOZL: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'a_o_z'
    })
    AOZ: PassOrFail;

    @Column({
        type: 'int',
        nullable: true,
        name: 'a_m_o_z_l'
    })
    AMOZL: number;


    @Column({
        type: 'int',
        nullable: true,
        name: 'a_m_o_z'
    })
    AMOZ: PassOrFail;

    @Column({
        type: 'int',
        nullable: true,
        name: 's_e_m'
    })
    SEM: PassOrFail;

    @Column({
        type: 'int',
        nullable: true,
        name: 'a_h_d'
    })
    AHD: PassOrFail;


       @Column('enum',{
            nullable: false,
            name: 'test_result',
            enum:PassOrFail
        })
        overAll: PassOrFail;
        
        @Column("varchar", {
            nullable: false,
            length: 30,
            name: "test_at"
        })
        qcAt: string;
        

    // @Column({
    //     type: 'int',
    //     nullable: true,
    //     name: 'test_result'
    // })
    // overAll: PassOrFail;

    @Column({
        type: 'int',
        nullable: true,
        name: 'alloted_lab'
    })
    allotedLab: AllocatedLab;


    @Column({
        type: 'varchar',
        nullable: true,
        name: 'c_a_p_details'
    })
    capDetails: string;

    @Column({
        type: 'varchar',
        nullable: true,
        name: 'a_o_z_details'
    })
    aozDetails: string;


    @Column({
        type: 'varchar',
        nullable: true,
        name: 'a_m_o_z_details'
    })
    amozDetails: string;


    @Column({
        type: 'varchar',
        nullable: true,
        name: 'a_h_d_details'
    })
    ahdDetails: string;


    @Column({
        type: 'varchar',
        nullable: true,
        name: 's_e_m_details'
    })
    semDetails: string;


    @Column('varchar', {
        nullable: true,
        length: 30,
        name: 'remarks'
    })
    remarks: string;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @CreateDateColumn({
        name: "Date_of_sampling",
        type: "datetime"
    })
    currentDate: Date;

    @Column('varchar', {
        nullable: true,
        length: 250,
        name: 'location'
    })
    location: string;

    @Column({
        name: 'test_status',
        nullable:false,
        default:false,
    })
    testStatus: boolean; 

    @Column({
        type:'enum',
        enum: AntibioticsTestStatus, 
        name: 'antibiotics_test_status',
        nullable:false,
        default:AntibioticsTestStatus.PENDING,
    })
    antibioticsTestStatus: AntibioticsTestStatus; 

    @Column({
        name:'lab_name',
        nullable:false,
        default:null
    })
    labName: string;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}